import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { FitnessGoal, FitnessGoalsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class FitnessGoalsDataService {

  private uri: string = `${environment.apiUrl}fitness-goals`;
  private cacheKey: string = 'fitnessGoals.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getFitnessGoal(id: number): Observable<FitnessGoal|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getFitnessGoals(parameters: {[param: string]: string | string[]}): Observable<FitnessGoalsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addFitnessGoal(data: FitnessGoal): Observable<FitnessGoal|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addFitnessGoals(data: FitnessGoal[]): Observable<FitnessGoal[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateFitnessGoal(data: FitnessGoal): Observable<FitnessGoal|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateFitnessGoals(data: FitnessGoal[]): Observable<FitnessGoal[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchFitnessGoal(data: FitnessGoal): Observable<FitnessGoal|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchFitnessGoals(data: FitnessGoal[]): Observable<FitnessGoal[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteFitnessGoal(data: FitnessGoal): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteFitnessGoals(data: FitnessGoal[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((fitnessGoal) => {
      ids.push(fitnessGoal.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
